/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 * ---------------------------------------------------------------------------------------------
 */

import { defineMessages } from 'react-intl';

export interface IChecklist {
  id: number,
  isChecked: boolean,
  text: any
}

let checklist: IChecklist[] = [
  {
    id: 0,
    isChecked: false,
    text: defineMessages({
      label: {
        id: 'readiness-checklist-label-0',
        defaultMessage: `My bot {link} and {link2} including "help" and erroneous commands.`
      },
      url: {
        id: 'readiness-checklist-label-0-url',
        defaultMessage: 'https://docs.microsoft.com/en-us/microsoftteams/platform/concepts/deploy-and-publish/appsource/prepare/frequently-failed-cases#-bots-must-send-a-welcome-message-on-first-launch',
      },
      linkText: {
        id: 'readiness-checklist-label-0-link-text',
        defaultMessage: 'sends a proactive welcome message',
      },
      url2: {
        id: 'readiness-checklist-label-1-url',
        defaultMessage: 'https://docs.microsoft.com/en-us/microsoftteams/platform/concepts/deploy-and-publish/appsource/prepare/frequently-failed-cases#-bots-must-always-be-responsive-and-fail-gracefully',
      },
      linkText2: {
        id: 'readiness-checklist-label-1-link-text',
        defaultMessage: 'responds to any commands entered by the user',
      }
    })
  },
  {
    id: 1,
    isChecked: false,
    text: defineMessages({
      label: {
        id: 'readiness-checklist-label-1',
        defaultMessage: `My tab pins a focused web page that {link}.`
      },
      url: {
        id: 'readiness-checklist-label-1-url',
        defaultMessage: 'https://docs.microsoft.com/en-us/microsoftteams/platform/concepts/deploy-and-publish/appsource/prepare/frequently-failed-cases#-tab-content-should-not-have-excessive-chrome-or-layered-navigation',
      },
      linkText: {
        id: 'readiness-checklist-label-1-link-text',
        defaultMessage: 'does not show complex sub-navigation',
      },
    })
  },
  {
    id: 2,
    isChecked: false,
    text: defineMessages({
      label: {
        id: 'readiness-checklist-label-2',
        defaultMessage: `My bot/connector metadata (e.g. name, icon) is consistent across my manifest, Azure Portal, Bot Framework, and Connector Portal.`
      }
    })
  },
  {
    id: 3,
    isChecked: false,
    text: defineMessages({
      label: {
        id: 'readiness-checklist-label-3',
        defaultMessage: `My app provides  (e.g. If there is an explicit sign-in option, there must be a corresponding sign-out option).`
      },
      url: {
        id: 'readiness-checklist-label-3-url',
        defaultMessage: 'https://docs.microsoft.com/en-us/microsoftteams/platform/concepts/deploy-and-publish/appsource/prepare/frequently-failed-cases#--provide-a-clear-and-simple-sign-insign-out-and-sign-up-experience',
      },
      linkText: {
        id: 'readiness-checklist-label-3-link-text',
        defaultMessage: 'a clear and simple sign in/out experience',
      },
    })
  },
  {
    id: 4,
    isChecked: false,
    text: defineMessages({
      label: {
        id: 'readiness-checklist-label-4',
        defaultMessage: `I will provide step-by-step {link} and any licensed credentials needed to test all scenarios of my app.`
      },
      url: {
        id: 'readiness-checklist-label-2-url',
        defaultMessage: 'https://docs.microsoft.com/en-us/microsoftteams/platform/concepts/deploy-and-publish/appsource/prepare/submission-checklist#test-notes-for-validation',
      },
      linkText: {
        id: 'readiness-checklist-label-4-link-text',
        defaultMessage: 'test notes',
      }
    })
  },
  {
    id: 5,
    isChecked: false,
    text: defineMessages({
      label: {
        id: 'readiness-checklist-label-5',
        defaultMessage: `Developer name, app title, descriptions, {link} and {link2} links are consistent across my manifest and the Partner Center.`
      },
      url: {
        id: 'readiness-checklist-label-5-url',
        defaultMessage: 'https://docs.microsoft.com/en-us/microsoftteams/platform/concepts/deploy-and-publish/appsource/prepare/submission-checklist#privacy-policy',
      },
      linkText: {
        id: 'readiness-checklist-label-5-link-text',
        defaultMessage: 'privacy policy',
      },
      url2: {
        id: 'readiness-checklist-label-5-url-2',
        defaultMessage: 'https://docs.microsoft.com/en-us/microsoftteams/platform/concepts/deploy-and-publish/appsource/prepare/submission-checklist#terms-of-use',
      },
      linkText2: {
        id: 'readiness-checklist-label-5-link-text-2',
        defaultMessage: 'terms of use',
      }
    })
  },
  {
    id: 6,
    isChecked: false,
    text: defineMessages({
      label: {
        id: 'readiness-checklist-label-6',
        defaultMessage: `All my app URLs are hosted on {link} (eg. secure company website HTTPs, under direct control of my company etc.).`
      },
      url: {
        id: 'readiness-checklist-label-6-url',
        defaultMessage: 'https://docs.microsoft.com/en-us/microsoftteams/platform/resources/schema/manifest-schema#validdomains',
      },
      linkText: {
        id: 'readiness-checklist-label-6-link-text',
        defaultMessage: 'valid domains',
      }
    })
  }
];

export default checklist;